import React from 'react'
import { View, ScrollView, TouchableOpacity } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { ProfileHeader, Text, Icon } from '@components'
import { useMenu } from './hook'
import { getMenuStyles } from './style'
import { MenuItem } from './components/MenuItem'
import { getMenuItems } from './constants'
import { useLanguage } from '@context'
import { useAdminMenu } from '@hooks'
import { Config } from '@config'

const appVersion = Config.APP_VERSION ?? ''

export const Menu: React.FC = () => {
  const theme = useTheme()
  const { navigateToProfile, navigateToScreen, signOut } = useMenu()
  const { t } = useLanguage()
  const styles = getMenuStyles(theme)
  const { isSuperAdmin, pendingCount } = useAdminMenu()
  const menuItems = getMenuItems(t, { isSuperAdmin })

  const handleMenuItemPress = (screen: string) => {
    navigateToScreen(screen as any)
  }

  const handleProfilePress = () => {
    navigateToProfile()
  }

  return (
    <View style={styles.container}>
      <ProfileHeader onProfilePress={handleProfilePress} />

      <ScrollView style={styles.scrollView} showsVerticalScrollIndicator={false}>
        <View style={styles.menuContainer}>
          {menuItems.map((item) => (
            <MenuItem
              key={item.id}
              item={item}
              onPress={handleMenuItemPress}
              badgeCount={item.screen === 'Admin' ? pendingCount : 0}
            />
          ))}
          <TouchableOpacity style={styles.logoutButton} onPress={signOut} activeOpacity={0.7}>
            <View style={styles.iconContainer}>
              <Icon name="logout" size={15} color="#666" />
            </View>
            <Text type="bodySmall" style={styles.logoutText}>
              {t('menu.signOut')}
            </Text>
          </TouchableOpacity>
          {appVersion ? (
            <Text type="bodyExtraSmall" style={styles.versionText}>
              {t('menu.version', { version: appVersion })}
            </Text>
          ) : null}
        </View>
      </ScrollView>
    </View>
  )
}
